import React from 'react';
import PropTypes from 'prop-types';
import DialogModal from 'shared/components/DialogModal';
import LogHistory from '../Components/LogHistory'
import { Stack } from '@mui/material';
import AppScrollbar from '@crema/core/AppScrollbar'

const DialogListRiwayat = ({ open, title, data, handleClose }) => {

    return (
        <DialogModal open={open} title={title} handleClose={handleClose} size={'xs'}>
            <Stack minHeight={300} position={'relative'}>
                <LogHistory data={data?.logs} />
            </Stack>
        </DialogModal >
    )
}

DialogListRiwayat.propTypes = {
    title: PropTypes.string,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    data: PropTypes.array
}

export default DialogListRiwayat